// extracted by mini-css-extract-plugin
export default {"exitFullscreenButton":"exit-fullscreen-button_exitFullscreenButton__ezDt8"};